module.exports = __webpack_public_path__ + "img/img_019@2x.10a04dd0.png";